Promise.all([import('../../plugins/semantic/form')]).then(() => {
  Promise.all([
    import(/* webpackMode: "eager" */ './park-summary.scss'),
    import('../../plugins/semantic/popup'),
    import('../../plugins/semantic/popup.css'),
  ]).then(() => {
    $('.widget.park-summary').each(function (i, el) {
      $(el).data('widget', new ParkSummary(el))
      $(el).data('widget').init()
    })
  })
})

function ParkSummary(el) {
  const self = this
  self.el = $(el)

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('ParkSummary init', self)
    }
    self.el.css('opacity', 1)

    self.el.find('.header').click(function (event) {
      event.preventDefault()
      $(this).parents('.feature-accordion').find('.content').slideToggle()
      $(this).parents('.feature-accordion').toggleClass('expanded')

      let widest = 0

      self.el.find('.feature').each(function (i, el) {
        const thisWidth = $(this).outerWidth()
        if (thisWidth > widest) {
          widest = thisWidth
        }

        if ($(window).width() > 1024) {
          $(el).find('.icon').popup({
            on: 'hover',
            position: 'top left',
          })
        }
      })

      self.el.find('.feature').css('width', widest)
    })
  }
}
